class ProductSpecToggle extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('.product-spec[data-collapsible="true"]');
    const toggleBtn = this.querySelector('.product-spec__toggle');
    if (!list || !toggleBtn || this.initialized) return;
    this.initialized = true;

    const items = Array.from(list.querySelectorAll('.product-spec__item'));
    const initiallyVisible = parseInt(list.dataset.initialVisible || '8', 10);
    const moreLabel = list.dataset.moreLabel || 'Show all characteristics';
    const lessLabel = list.dataset.lessLabel || 'Show less';

    if (items.length <= initiallyVisible) {
      toggleBtn.hidden = true;
      return;
    }

    let expanded = false;
    const update = () => {
      items.forEach((item, index) => {
        item.hidden = !expanded && index >= initiallyVisible;
      });
      toggleBtn.textContent = expanded ? lessLabel : moreLabel;
      toggleBtn.setAttribute('aria-expanded', String(expanded));
    };

    toggleBtn.hidden = false;
    update();
    toggleBtn.addEventListener('click', () => {
      expanded = !expanded;
      update();
    });
  }
}

if (!customElements.get('m-product-spec-toggle')) {
  customElements.define('m-product-spec-toggle', ProductSpecToggle);
}
